import React from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
 const email = sessionStorage.getItem('agencyEmail');

  return (
    <header className='bg-[#F4F6F9] py-[15px] shadow-md w-full'>
      <div className='flex items-center justify-between px-10 mx-auto w-full'>
        <div className='flex justify-start items-center pl-0 shrink-0'>
          <Link to='/'>
            <img
              src='/logo/logo.svg'
              alt='Takagi Seiko Logo'
              className='h-auto w-auto max-h-[60px] object-contain [image-rendering:crisp-edges] cursor-pointer'
            />
          </Link>
        </div>

        {email && (
          <div className="flex items-center gap-4 shrink-0">
            <div className="text-sm text-gray-700">{email}</div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
